import { render, staticRenderFns } from "./ReceiptPeriodSchema.vue?vue&type=template&id=6eff4822"
import script from "./ReceiptPeriodSchema.vue?vue&type=script&lang=ts"
export * from "./ReceiptPeriodSchema.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports